export const useArticleUri = () => {
    const { isMicrosite, microsite } = storeToRefs(useMicrositeStore())

    const articleUri = (articleUri: string) => {
        if (isMicrosite.value) {
            return `/${microsite.value.uri}/${articleUri}`
        }

        return `/${articleUri}`
    }

    return {
        articleUri,
    }
}
